<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Edycja oferty</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/allegro/accounts/list">
            Allegro - Moje konta
          </router-link>
        </li>
        <li v-if="accountPk">
          <router-link :to="`/allegro/accounts/${accountPk}/overview`">
            {{ accountName }}
          </router-link>
        </li>
        <li v-if="accountPk">
          <router-link :to="`/allegro/accounts/${accountPk}/offers`">
            Oferty
          </router-link>
        </li>
        <li class="active">
          <strong>{{ offerObj.signature || "Edycja oferty" }}</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dane oferty</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-12 m-b-xs">
                  <div class="form-group">
                    <label class="control-label col-sm-2">Produkt *</label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.product"
                        mode="single"
                        placeholder="Produkt"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :disabled="isProductDataComplete"
                        :options="products"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.product"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.product[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">Nakład *</label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.quantity"
                        mode="single"
                        placeholder="Nakład"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :disabled="isProductDataComplete"
                        :options="quantities"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.quantity"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.quantity[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="group in visibleGroupOptions"
                    class="form-group"
                    :key="group.group_option.pk"
                  >
                    <label class="control-label col-sm-2">
                      {{ group.group_option.name }}
                      <span>*</span>
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="selectedProductOptions[group.group_option.pk]"
                        :mode="
                          group.group_option.is_multiple ? 'tags' : 'single'
                        "
                        :placeholder="group.group_option.name"
                        track-by="pk"
                        label="label"
                        :close-on-select="!group.group_option.is_multiple"
                        :searchable="true"
                        :disabled="isProductDataComplete"
                        :options="group.options"
                      >
                      </Multiselect>
                      <div
                        v-if="submitted && getGroupOptionError(group)"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ getGroupOptionError(group) }}
                        </span>
                      </div>
                      <div
                        v-if="errorsAdminData?.data?.chosen_options"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.chosen_options[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">Tytuł *</label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.title"
                        type="text"
                        class="form-control inputClass"
                        placeholder="Tytuł"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.title"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.title[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">Sygnatura *</label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.signature"
                        type="text"
                        maxlength="100"
                        class="form-control inputClass"
                        placeholder="Sygnatura"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.signature"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.signature[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">Opis *</label>
                    <div class="col-sm-10">
                      <Editor
                        api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                        v-model="offerObj.description"
                        :init="{
                          toolbar_mode: 'sliding',
                          plugins:
                            'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                          toolbar:
                            'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                        }"
                      />
                      <div
                        v-if="errorsAdminData?.data?.price"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.price[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">
                      Dostępna ilość kompletów *
                    </label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.available_number"
                        type="number"
                        class="form-control inputClass"
                        placeholder="Dostępna ilość kompletów"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.available_number"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.available_number[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">Cena *</label>
                    <div class="col-sm-10">
                      <input
                        v-model="offerObj.price"
                        type="number"
                        class="form-control inputClass"
                        placeholder="Cena"
                        required="required"
                      />
                      <div
                        v-if="errorsAdminData?.data?.price"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.price[0] }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-2">
                      Cennik dostawy *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.data.shoppingRate"
                        mode="single"
                        placeholder="Cennik dostawy"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="rates"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.returnPolicy"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.returnPolicy[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">
                      Warunki reklamacji *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.data.impliedWarranty"
                        mode="single"
                        placeholder="Warunki reklamacji"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="warranties"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.returnPolicy"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.returnPolicy[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">
                      Warunki zwrotów *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.data.returnPolicy"
                        mode="single"
                        placeholder="Warunki zwrotów"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="returns"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.returnPolicy"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.returnPolicy[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">
                      Czas publikacji *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.publication_duration"
                        mode="single"
                        placeholder="Czas publikacji"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="durations"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.publication_duration"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.publication_duration[0] }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-offset-2 col-sm-10 mb-25">
                    <div>
                      <label>
                        <input v-model="offerObj.republish" type="checkbox" />
                        <span> Wznów automatycznie publikację</span>
                      </label>
                    </div>
                    <div>
                      <small class="form-text text-muted ng-scope">
                        Oferta wznawiana jest ze stałą początkową liczbą
                        przedmiotów niezależnie od tego, ile przedmiotów
                        sprzedasz.
                      </small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label col-sm-2">
                      Czas wysyłki *
                    </label>
                    <div class="col-sm-10">
                      <Multiselect
                        v-model="offerObj.delivery_handling_time"
                        mode="single"
                        placeholder="Czas wysyłki"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :options="times"
                      >
                      </Multiselect>
                      <div
                        v-if="errorsAdminData?.data?.delivery_handling_time"
                        class="has-error"
                      >
                        <span class="help-block">
                          {{ errorsAdminData.data.delivery_handling_time[0] }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-sm-4 col-sm-offset-2">
                      <router-link
                        class="btn btn-white"
                        :to="`/allegro/accounts/${accountPk}/offers`"
                      >
                        Anuluj
                      </router-link>
                      <button
                        v-if="canChangeOffer"
                        :disabled="isSubmitting"
                        @click="saveEdit"
                        class="btn btn-primary"
                      >
                        {{ isSubmitting ? "Zapisywanie..." : "Zapisz" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref } from "vue";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import Editor from "@tinymce/tinymce-vue";
import { useRoute } from "vue-router";
import router from "../../router/router";
import {
  allegroOfferMessagesConst,
  allegroOfferPermissionsConst,
} from "../../constants/allegroConstants";
import { hasPermission } from "../../permissions";

// Flattens a DRF error payload down to the first readable message
const getFirstErrorMessage = (data) => {
  const entries = Object.entries(data || {});
  if (!entries.length) {
    return allegroOfferMessagesConst.error;
  }
  const [key, value] = entries[0];
  return `${key}: ${Array.isArray(value) ? value[0] : value}`;
};

export default {
  name: "OffersCreate",
  mixins: [],
  components: {
    Multiselect,
    Editor,
  },
  props: {},

  setup() {
    const store = useStore();
    const route = useRoute();

    const canChangeOffer = computed(() =>
      hasPermission(allegroOfferPermissionsConst.update)
    );

    const adminGPData = computed(() => store.getters.getAdminGPData);
    const adminQuantitiesData = computed(
      () => store.getters.getAdminQuantitiesData
    );
    const allDeliveryTimesData = computed(
      () => store.getters.getAllDeliveryTimesData
    );
    const allDurationsPubData = computed(
      () => store.getters.getAllDurationsPubData
    );
    const allReturnData = computed(() => store.getters.getAllReturnData);
    const allWarrantiesData = computed(
      () => store.getters.getAllWarrantiesData
    );
    const allShopingRatesData = computed(
      () => store.getters.getAllShopingRatesData
    );
    const allOfferData = computed(() => store.getters.getAllOfferData);
    const allUpdateOfferData = computed(
      () => store.getters.getUpdateAllOfferData
    );
    const offerObj = ref({
      chosen_options: [],
      data: {},
    });
    // The Allegro account of the edited offer - the dictionaries are read
    // through its OAuth configuration, so they wait for the offer to load.
    const accountPk = ref(null);
    const accountName = computed(() => offerObj.value?.account?.name || "-");

    const rates = ref([]);
    const warranties = ref([]);
    const returns = ref([]);
    const durations = ref([]);
    const times = ref([]);
    const products = ref([]);

    const quantities = ref([]);
    const gps = ref([]);
    const selectedProductOptions = ref({});
    const errorsAdminData = ref();

    // Product, quantity and options are locked once the offer already has
    // them - the same rule the old admin panel applies on the edit form.
    const isProductDataComplete = computed(
      () =>
        Boolean(offerObj.value.product) &&
        Boolean(offerObj.value.quantity) &&
        Object.keys(selectedProductOptions.value).length > 0
    );

    // Groups that let the client type in their own value cannot be expressed
    // in an Allegro offer, so the old admin panel hides them from the form.
    const isPossibleDisplayProductGroupOption = (group) =>
      (group.options || []).some((option) => option.enter_values_possible);

    const visibleGroupOptions = computed(() =>
      gps.value.filter((group) => !isPossibleDisplayProductGroupOption(group))
    );

    // Required product option groups, validated like form.$valid does it in
    // the old admin panel
    const submitted = ref(false);
    const isSubmitting = ref(false);

    const isValueEmpty = (value) =>
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    const getGroupOptionError = (group) => {
      const value = selectedProductOptions.value[group.group_option.pk];
      return isValueEmpty(value) ? "To pole nie może być puste." : null;
    };

    // Options are kept per group pk and flattened to plain pks on save -
    // the update serializer expects a list of ids, not the loaded objects.
    const chosenOptionPks = () =>
      Object.values(selectedProductOptions.value)
        .flat()
        .filter((pk) => pk !== undefined && pk !== null && pk !== "");
    const asList = (data, keys = []) => {
      if (Array.isArray(data)) {
        return data;
      }
      if (Array.isArray(data?.results)) {
        return data.results;
      }
      for (const key of keys) {
        if (Array.isArray(data?.[key])) {
          return data[key];
        }
      }
      return [];
    };

    store.dispatch("getAllOffer", route.params?.pk);
    // The product select is read only here, it just needs the option that
    // matches the offer so the picked product renders with its label.
    store.dispatch("getAllProducts").then((response) => {
      products.value = (response.data?.results || []).map((element) => ({
        name: "[" + element.pk + "] " + element.name,
        value: element.pk,
      }));
    });

    const getOfferDictionaries = () => {
      const payload = { accountPk: accountPk.value };
      store.dispatch("getAllShopingRates", payload);
      store.dispatch("getAllWarranties", payload);
      store.dispatch("getAllDeliveryTimes", payload);
      store.dispatch("getAllDurationsPub", payload);
      store.dispatch("getAllReturn", payload);
    };

    const saveEdit = () => {
      if (!canChangeOffer.value) {
        return;
      }
      if (isSubmitting.value) {
        return;
      }
      submitted.value = true;

      if (
        visibleGroupOptions.value.some((group) => getGroupOptionError(group))
      ) {
        store.dispatch("showToaster", {
          type: "error",
          content: "Uzupełnij wymagane pola formularza.",
        });
        return;
      }

      isSubmitting.value = true;
      store.dispatch("updateAllOffer", {
        ...offerObj.value,
        chosen_options: chosenOptionPks(),
      });
    };

    watch(
      () => allOfferData.value,
      function (newValue) {
        offerObj.value = newValue.data;
        accountPk.value = newValue.data?.account?.pk || null;

        // chosen_options come back as {pk, options_group} pairs
        selectedProductOptions.value = {};
        (newValue.data?.chosen_options || []).forEach((option) => {
          selectedProductOptions.value[option.options_group] = option.pk;
        });

        if (accountPk.value) {
          getOfferDictionaries();
        }
      }
    );

    watch(
      () => allUpdateOfferData.value,
      function (newValue) {
        isSubmitting.value = false;

        if (newValue.status >= 200 && newValue.status < 300) {
          const externalErrors = newValue.data?.external_errors || {};

          if (Object.keys(externalErrors).length === 0) {
            // The toast is raised once the navigation settled - showing it
            // first makes the redirect cut it off after a blink.
            router
              .push(`/allegro/accounts/${accountPk.value}/offers`)
              .then(() => {
                store.dispatch("showToaster", {
                  type: "success",
                  content: allegroOfferMessagesConst.update,
                });
              });
            return;
          }

          // Allegro rejected the change - the old panel shows the errors and
          // keeps the user on the edit form.
          store.dispatch("showToaster", {
            type: "success",
            content: allegroOfferMessagesConst.update,
          });
          store.dispatch("showToaster", {
            type: "error",
            content: getFirstErrorMessage(externalErrors),
          });
          return;
        }

        store.dispatch("showToaster", {
          type: "error",
          content: getFirstErrorMessage(newValue.data),
        });
        errorsAdminData.value = newValue;
      }
    );

    watch(
      () => allDeliveryTimesData.value,
      function (newValue) {
        times.value = [];
        asList(newValue?.data, ["deliveryHandlingTimes"]).forEach((element) => {
          times.value.push({
            name: element.name,
            value: element.id,
          });
        });
      }
    );

    watch(
      () => allDurationsPubData.value,
      function (newValue) {
        durations.value = [];
        asList(newValue?.data, ["publicationDurations"]).forEach((element) => {
          durations.value.push({
            name: element.name,
            value: element.id,
          });
        });
      }
    );

    watch(
      () => allReturnData.value,
      function (newValue) {
        returns.value = asList(newValue?.data, ["returnPolicies"]).map(
          (element) => ({
            name: element.name,
            value: element.id,
          })
        );
      }
    );

    watch(
      () => allShopingRatesData.value,
      function (newValue) {
        rates.value = asList(newValue?.data, ["shippingRates"]).map(
          (element) => ({
            name: element.name,
            value: element.id,
          })
        );
      }
    );
    watch(
      () => allWarrantiesData.value,
      function (newValue) {
        warranties.value = asList(newValue?.data, ["impliedWarranties"]).map(
          (element) => ({
            name: element.name,
            value: element.id,
          })
        );
      }
    );

    watch(
      () => offerObj.value?.product,
      function (newValue) {
        store.dispatch("getAdminQuantities", newValue);
        store.dispatch("getAdminGP", newValue);
      }
    );

    watch(
      () => adminQuantitiesData.value,
      function (newValue) {
        quantities.value = [];
        newValue.data?.forEach((element) => {
          quantities.value.push({
            name: "[" + element.pk + "] " + element.display_quantity,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => adminGPData.value,
      function (newValue) {
        let options = [];
        gps.value = [];
        newValue.data?.forEach((element) => {
          options = [];
          element.options.forEach((option) => {
            option.value = option.pk;
            options.push(option);
          });
          element.options = options;
          gps.value.push(element);
        });
      }
    );

    return {
      canChangeOffer,
      offerObj,
      products,
      quantities,
      gps,
      visibleGroupOptions,
      submitted,
      isSubmitting,
      getGroupOptionError,
      selectedProductOptions,
      isProductDataComplete,
      errorsAdminData,
      times,
      durations,
      returns,
      warranties,
      rates,
      saveEdit,
      accountPk,
      accountName,
    };
  },
  computed: {},
};
</script>
